const Footer = () => {
    return (
        <footer className='text-center'>
            © 2023 • Destination Solutions •{' '}
            <a
                href='https://www.ds-destinationsolutions.com/impressum'
                aria-label='DS Destination Solutions Impressum'
                target='_blank'
                rel='noreferrer'
            >
                Impressum
            </a>{' '}
            •{' '}
            <a
                href='https://www.ds-destinationsolutions.com/datenschutz'
                aria-label='DS Destination Solutions Kontakt-Link'
                target='_blank'
                rel='noreferrer'
            >
                Datenschutz
            </a>
        </footer>
    )
}

export default Footer
